import React from 'react';

type Props = {
  name: string,
  label: string,
  record?: any
};

const ChangeComment = (props: Props) => (
  <div title={new Date(props.record.created_at).toLocaleString()}>
    {props.record && props.record.generated_comment}<br />
    <i>{props.record && props.record.comment}</i>
  </div>
);

export default ChangeComment;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/ChangeComment.tsx